import {
  regionListConstants,
  downloadVersionFileConstants,
  globalReleasesConstants,
  checksumAlgorthmConstants,
  hm5GlobalReleasesConstants,
  saGlobalReleasesConstants,
  vs2jen2GlobalReleasesConstants,
  uaGlobalReleasesConstants,
  vs2ngaGlobalReleasesConstants,
  hmplusGlobalReleasesConstants,
} from "../_redux-constants/";

export function commonReducer(
  state = {
    regionListLoading: false,
    regionListData: null,
    regionListError: null,

    downloadVersionFileLoading: false,
    downloadVersionFileData: null,
    downloadVersionFileError: null,

    globalReleasesListLoading: false,
    globalReleasesListData: null,
    globalReleasesListError: null,

    checksumAlgorithmListLoading: false,
    checksumAlgorithmListData: null,
    checksumAlgorithmListError: null,

    hm5GlobalReleasesListLoading: false,
    hm5GlobalReleasesListData: null,
    hm5GlobalReleasesListError: null,

    hmplusGlobalReleasesListLoading: false,
    hmplusGlobalReleasesListData: null,
    hmplusGlobalReleasesListError: null,

    uaGlobalReleasesListLoading: false,
    uaGlobalReleasesListData: null,
    uaGlobalReleasesListError: null,

    saGlobalReleasesListLoading: false,
    saGlobalReleasesListData: null,
    saGlobalReleasesListError: null,

    vs2jen2GlobalReleasesListLoading: false,
    vs2jen2GlobalReleasesListData: null,
    vs2jen2GlobalReleasesListError: null,

    vs2ngaGlobalReleasesListLoading: false,
    vs2ngaGlobalReleasesListData: null,
    vs2ngaGlobalReleasesListError: null,
  },
  action
) {
  switch (action.type) {
    case regionListConstants.REGION_LIST_LOADING:
      return Object.assign({}, state, {
        regionListLoading: true,
        regionListData: null,
        regionListError: null,
      });
    case regionListConstants.REGION_LIST_SUCCESS:
      return Object.assign({}, state, {
        regionListLoading: false,
        regionListData: action.data,
      });
    case regionListConstants.REGION_LIST_FAILURE:
      return Object.assign({}, state, {
        regionListLoading: false,
        regionListData: null,
        regionListError: action.error,
      });
    case downloadVersionFileConstants.DWNLD_VERSION_FILE_LOADING:
      return Object.assign({}, state, {
        downloadVersionFileLoading: true,
        downloadVersionFileData: null,
        downloadVersionFileError: null,
      });
    case downloadVersionFileConstants.DWNLD_VERSION_FILE_SUCCESS:
      return Object.assign({}, state, {
        downloadVersionFileLoading: false,
        downloadVersionFileData: action.data,
      });
    case downloadVersionFileConstants.DWNLD_VERSION_FILE_FAILURE:
      return Object.assign({}, state, {
        downloadVersionFileLoading: false,
        downloadVersionFileData: null,
        downloadVersionFileError: action.error,
      });
    case globalReleasesConstants.GLOBAL_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        globalReleasesListLoading: true,
        globalReleasesListData: null,
        globalReleasesListError: null,
      });
    case globalReleasesConstants.GLOBAL_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        globalReleasesListLoading: false,
        globalReleasesListData: action.data,
      });
    case globalReleasesConstants.GLOBAL_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        globalReleasesListLoading: false,
        globalReleasesListData: null,
        globalReleasesListError: action.error,
      });
    case checksumAlgorthmConstants.CHECKSUM_ALGORITHM_LIST_LOADING:
      return Object.assign({}, state, {
        checksumAlgorithmListLoading: true,
        checksumAlgorithmListData: null,
        checksumAlgorithmListError: null,
      });
    case checksumAlgorthmConstants.CHECKSUM_ALGORITHM_LIST_SUCCESS:
      return Object.assign({}, state, {
        checksumAlgorithmListLoading: false,
        checksumAlgorithmListData: action.data,
      });
    case checksumAlgorthmConstants.CHECKSUM_ALGORITHM_LIST_FAILURE:
      return Object.assign({}, state, {
        checksumAlgorithmListLoading: false,
        checksumAlgorithmListData: null,
        checksumAlgorithmListError: action.error,
      });
    case hm5GlobalReleasesConstants.HM5_GLOBAL_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        hm5GlobalReleasesListLoading: true,
        hm5GlobalReleasesListData: null,
        hm5GlobalReleasesListError: null,
      });
    case hm5GlobalReleasesConstants.HM5_GLOBAL_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        hm5GlobalReleasesListLoading: false,
        hm5GlobalReleasesListData: action.data,
      });
    case hm5GlobalReleasesConstants.HM5_GLOBAL_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        hm5GlobalReleasesListLoading: false,
        hm5GlobalReleasesListData: null,
        hm5GlobalReleasesListError: action.error,
      });
    case uaGlobalReleasesConstants.UA_GLOBAL_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        uaGlobalReleasesListLoading: true,
        uaGlobalReleasesListData: null,
        uaGlobalReleasesListError: null,
      });
    case uaGlobalReleasesConstants.UA_GLOBAL_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        uaGlobalReleasesListLoading: false,
        uaGlobalReleasesListData: action.data,
      });
    case uaGlobalReleasesConstants.UA_GLOBAL_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        uaGlobalReleasesListLoading: false,
        uaGlobalReleasesListData: null,
        uaGlobalReleasesListError: action.error,
      });
    case saGlobalReleasesConstants.SA_GLOBAL_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        saGlobalReleasesListLoading: true,
        saGlobalReleasesListData: null,
        saGlobalReleasesListError: null,
      });
    case saGlobalReleasesConstants.SA_GLOBAL_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        saGlobalReleasesListLoading: false,
        saGlobalReleasesListData: action.data,
      });
    case saGlobalReleasesConstants.SA_GLOBAL_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        saGlobalReleasesListLoading: false,
        saGlobalReleasesListData: null,
        saGlobalReleasesListError: action.error,
      });
    case vs2jen2GlobalReleasesConstants.VS2JEN2_GLOBAL_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        vs2jen2GlobalReleasesListLoading: true,
        vs2jen2GlobalReleasesListData: null,
        vs2jen2GlobalReleasesListError: null,
      });
    case vs2jen2GlobalReleasesConstants.VS2JEN2_GLOBAL_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        vs2jen2GlobalReleasesListLoading: false,
        vs2jen2GlobalReleasesListData: action.data,
      });
    case vs2jen2GlobalReleasesConstants.VS2JEN2_GLOBAL_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        vs2jen2GlobalReleasesListLoading: false,
        vs2jen2GlobalReleasesListData: null,
        vs2jen2GlobalReleasesListError: action.error,
      });
    case vs2ngaGlobalReleasesConstants.VS2NGA_GLOBAL_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        vs2ngaGlobalReleasesListLoading: true,
        vs2ngaGlobalReleasesListData: null,
        vs2ngaGlobalReleasesListError: null,
      });
    case vs2ngaGlobalReleasesConstants.VS2NGA_GLOBAL_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        vs2ngaGlobalReleasesListLoading: false,
        vs2ngaGlobalReleasesListData: action.data,
      });
    case vs2ngaGlobalReleasesConstants.VS2NGA_GLOBAL_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        vs2ngaGlobalReleasesListLoading: false,
        vs2ngaGlobalReleasesListData: null,
        vs2ngaGlobalReleasesListError: action.error,
      });
    case hmplusGlobalReleasesConstants.HMPLUS_GLOBAL_RELEASES_LIST_LOADING:
      return Object.assign({}, state, {
        hmplusGlobalReleasesListLoading: true,
        hmplusGlobalReleasesListData: null,
        hmplusGlobalReleasesListError: null,
      });
    case hmplusGlobalReleasesConstants.HMPLUS_GLOBAL_RELEASES_LIST_SUCCESS:
      return Object.assign({}, state, {
        hmplusGlobalReleasesListLoading: false,
        hmplusGlobalReleasesListData: action.data,
      });
    case hmplusGlobalReleasesConstants.HMPLUS_GLOBAL_RELEASES_LIST_FAILURE:
      return Object.assign({}, state, {
        hmplusGlobalReleasesListLoading: false,
        hmplusGlobalReleasesListData: null,
        hmplusGlobalReleasesListError: action.error,
      });
    default:
      return state;
  }
}
